import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Navigate, Route, Routes } from "react-router";
import "./styles.css";
import { SessionProvider, useSession } from "./lib/session";
import { Shell } from "./components/Shell";
import { Login } from "./pages/Login";
import { Agenda } from "./pages/Agenda";
import { Requests } from "./pages/Requests";
import { Patients } from "./pages/Patients";
import { Roadmap } from "./pages/Roadmap";
import { Site } from "./pages/Site";
import { TeamSettings } from "./pages/TeamSettings";
import { Admins } from "./pages/Admins";

function App() {
  const { loading, isStaff, role } = useSession();
  if (loading) return <div className="boot" aria-busy="true" />;
  if (!isStaff) return <Login />;
  return (
    <Routes>
      <Route element={<Shell />}>
        <Route index element={<Navigate to="/agenda" replace />} />
        <Route path="agenda" element={<Agenda />} />
        <Route path="solicitudes" element={<Requests />} />
        <Route path="pacientes" element={<Patients />} />
        {(role === "superadmin" || role === "owner" || role === "branch_admin") && <Route path="profesionales" element={<TeamSettings />} />}
        {(role === "superadmin" || role === "owner") && <Route path="sitio" element={<Site />} />}
        {role === "superadmin" && <Route path="administradores" element={<Admins />} />}
        <Route path="*" element={<Roadmap />} />
      </Route>
    </Routes>
  );
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <SessionProvider>
      <BrowserRouter basename={import.meta.env.BASE_URL}>
        <App />
      </BrowserRouter>
    </SessionProvider>
  </StrictMode>,
);
